/* eslint-disable react/prop-types */
import React from 'react';

/**
 * The Android / iOS sub-section inside an installs card.
 *
 * Total Installs and the selected-range Installs are each ONE figure with this same
 * two-way platform split beside or beneath it, so each reads as a single box answering
 * "how many, and on what" — rather than three sibling boxes that have to be re-added.
 *
 * `inline` sets the split on the same line as the figure it belongs to, each platform
 * reading "Android 7,636" across rather than stacked. Both installs cards use it, so the
 * two read as the same shape. The selected-range card carries a bracketed delta after each
 * count as well, which is the widest case — the row wraps rather than overflowing when the
 * card is too narrow for it.
 *
 * An item may carry an `extra` node rendered straight after its count; the selected-range
 * card puts its bracketed period-over-period delta there, the all-time card passes none.
 *
 * Props: { testId, items, inline }  — items: [{ label, value, extra?, testId? }]
 */
const InstallationPlatformSplit = ({ testId, items = [], inline = false }) => (
  <div className={`inst-split${inline ? ' inst-split--inline' : ''}`} data-testid={testId}>
    {items.map((i) => (
      <span className="inst-split__item" key={i.label}>
        <span className="inst-split__k">{i.label}</span>
        <span className="inst-split__v inst-num" data-testid={i.testId}>
          {i.value}
          {i.extra}
        </span>
      </span>
    ))}
  </div>
);

export default InstallationPlatformSplit;
